import { LocalStorage } from 'utils/local-storage';
export default function authHeader() {
  let authenticatedUser = JSON.parse(LocalStorage.getItem("authenticatedUser"));

  if (authenticatedUser && authenticatedUser.authdata) {
    return { Authorization: 'Bearer ' + authenticatedUser.authdata };
  } else {
    return {};
  }
}
